import { useMemo } from "react";
import { Reveal, Overline } from "./Reveal";
import StatusBadge from "./StatusBadge";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../../lib/api";

export default function KurtaEdits({ products, onOpen }) {
  const kurtas = useMemo(() => products.filter((p) => p.category === "kurta"), [products]);
  const gridCols = kurtas.length % 4 === 0 ? "lg:grid-cols-4" : kurtas.length % 3 === 0 ? "lg:grid-cols-3" : "lg:grid-cols-4";

  return (
    <section id="kurtas" data-testid="kurta-edits" className="bg-charcoal grain text-cream py-24 md:py-36 relative overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 relative z-10">
        <Reveal>
          <Overline>Our Kurta Collection</Overline>
          <h2 className="mt-5 font-display font-black uppercase tracking-normal text-cream text-4xl md:text-6xl lg:text-7xl leading-[0.95] max-w-4xl">
            Carefully crafted. <span className="text-toga">Ready to wear.</span>
          </h2>
        </Reveal>

        <div className={`mt-16 grid grid-cols-1 sm:grid-cols-2 ${gridCols} gap-6`}>
          {kurtas.map((k, i) => {
            return (
              <Reveal key={k._id} delay={(i % 4) * 0.1}>
                <div data-testid={`kurta-card-${k._id}`} className="group border border-cream/15 bg-charcoal/40 h-full flex flex-col">
                  <button onClick={() => onOpen(k)} className="relative aspect-[3/4] overflow-hidden w-full">
                    <img src={k.image} alt={k.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute top-4 left-4"><StatusBadge status={k.status} /></div>
                  </button>
                  <div className="p-6 flex-1 flex flex-col">
                    <span className="text-xs tracking-[0.2em] uppercase font-bold text-toga">{k.subcategory}</span>
                    <h3 className="mt-2 font-display uppercase tracking-tight text-cream text-2xl font-bold">{k.name}</h3>
                    <p className="mt-3 text-sm text-cream/60 font-light flex-1">{k.description}</p>
                    <a
                      href={whatsappLink(`Hello TOGA, I'd like to inquire about the "${k.name}" kurta.`)}
                      target="_blank" rel="noreferrer"
                      data-testid={`kurta-inquire-${k._id}`}
                      className="mt-5 inline-flex items-center gap-2 text-cream text-xs uppercase tracking-[0.15em] font-bold hover:text-toga transition-colors"
                    >
                      <MessageCircle size={16} /> Inquire About This Design
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
